/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { GetProject } from './project.get';

const Params = z.strictObject({ organizationId: ZodTypes.Id, projectId: ZodTypes.Id });

export const PatchProject = {
  id: 'project.patch',
  tag: 'Project',
  summary: 'Patch project',
  description: 'Patch a project within an organization',
  method: 'patch',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/project/${params.projectId}`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            name: ZodTypes.KubernetesIdentifier.optional(),
            description: ZodTypes.TrimmedString.min(1).nullable().optional(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: GetProject.response['200'].content['application/json'].schema,
        },
      },
    },
  },
} as const satisfies Endpoint;
